import { FormMapper } from './FormMapper';

const allowedStatus = [3, 4, 5, 6];
export class FormApi {
  constructor(api) {
    this.api = api;
  }

  async get(formId) {
    const { data } = await this.api('getFormApi', { formId });
    return data;
  }

  async put(formId, form) {
    const data = FormMapper.mapFormToApi(form);
    const { status } = form;
    const headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
    if (allowedStatus.includes(status)) {
      await this.api('postForm', { formId }, null, data, headers, 'form-urlencoded');
    }
  }

  async updatedAt(formId) {
    const res = await this.api('getFormsApi', null, { id: formId });
    return res?.data?.updatedAt;
  }
}
